import { apiFetch } from './client';

const token = () => localStorage.getItem('token');

export const getMembers = (status = '') =>
  apiFetch(`/admin/members${status ? `?status=${encodeURIComponent(status)}&_t=${Date.now()}` : `?_t=${Date.now()}`}`, {
    token: token()
  });

export const getPendingMembers = () =>
  apiFetch(`/admin/members?status=pending&_t=${Date.now()}`, { token: token() });

export const approveMember = (id, body) =>
  apiFetch(`/admin/members/${id}/approve`, { method: 'PATCH', token: token(), body });

export const deactivateMember = (id) =>
  apiFetch(`/admin/members/${id}/deactivate`, { method: 'PATCH', token: token() });

export const activateMember = (id) =>
  apiFetch(`/admin/members/${id}/activate`, { method: 'PATCH', token: token() });

export const setUserRole = (id, role) =>
  apiFetch(`/admin/users/${id}/role`, {
    method: 'PATCH',
    token: token(),
    body: { role }
  });
